import { Pipe, PipeTransform } from '@angular/core';

import { OpportunityType } from '@shared/models/opportunity';

@Pipe({
  name: 'smsfOrCommercial'
})
export class SmsfOrCommercialPipe implements PipeTransform {
  transform(opportunityType: OpportunityType): boolean {
    // Define the base opportunity types that are always valid
    const validTypes = ['SMSF', 'Commercial'];

    // Check if the provided opportunity type is in the valid types list
    return validTypes.includes(opportunityType);
  }
}
